import React from "react";
import { Sidebar, SidebarContent } from "./Sidebar.jsx";
import { useTheme } from "next-themes";
import { useNavbarVisibility } from "@/context/NavbarVisibilityContext";

export default function DashboardSidebar({
  activeTab,
  setActiveTab,
  darkMode,
  setDarkMode,
  menuItems,
}) {
  const { theme } = useTheme();
  const { navbarVisible } = useNavbarVisibility();

  const items =
    menuItems ||
    [
      { id: "summary", title: "Summary" },
      { id: "insights", title: "Detailed Insights" },
      { id: "benchmarks", title: "Benchmarks" },
      { id: "roi", title: "ROI" },
    ];

  return (
    <Sidebar
      className={`p-0 w-48 fixed left-0 transition-all duration-300 z-20
        ${navbarVisible ? "top-24 h-[calc(100vh-6rem)]" : "top-0 h-screen"}
        ${darkMode ? "text-white border-r border-gray-700" : "border-r border-gray-200"}
      `}
    >
      <SidebarContent className="p-0">
        <nav>
          <ul className="space-y-1">
            {items.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => setActiveTab(item.id)}
                  className={`
                    w-full flex items-center gap-2 px-4 py-2 rounded transition-colors
                    ${activeTab === item.id ? (darkMode ? "bg-gray-700" : "bg-gray-100 font-semibold") : ""}
                    ${darkMode ? "hover:bg-gray-700" : "hover:bg-gray-50"}
                  `}
                >
                  {item.icon && <item.icon className="h-5 w-5 flex-shrink-0" />}
                  <span className="whitespace-nowrap text-sm">{item.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </SidebarContent>
    </Sidebar>
  );
}